import type { Tier } from '@/beta/types/catalog';

export interface TierBadgeProps {
  tier: Tier;
}

const LABELS: Record<Tier, string> = {
  vaulted: 'Vaulted',
  documented: 'Documented',
  partial: 'Partial',
  stub: 'Stub',
};

/** Square pill, 0px corners, --vm-tier-* background, white label.
 *  Spec § 6.1 — top-right of every chapter card. */
export function TierBadge({ tier }: TierBadgeProps) {
  return (
    <span
      data-tier={tier}
      style={{
        display: 'inline-block',
        padding: '4px 8px',
        background: `var(--vm-tier-${tier})`,
        color: 'var(--vm-warm-white)',
        fontFamily: 'var(--vm-font-heading)',
        fontSize: 9,
        lineHeight: 1,
        letterSpacing: '0.25em',
        textTransform: 'uppercase',
      }}
    >
      {LABELS[tier]}
    </span>
  );
}
